module.exports = __webpack_public_path__ + "static/Bosch-oversikt_hovedside2-5267f869fff6a082f2cd953ad6cc5ed0.png";